import {
  dashboardGraphqlToModel,
  listAllDashboardsForUserQuery,
  listAllDashboardsQuery,
} from '@akin-home/dashboards/frontend';

import {
  DashboardByUserQueryVariables,
  DashboardDeviceType,
  ListDashboardsQueryVariables,
} from '@akin-home/amplify';
import { useQuery } from 'react-query';
import { dashboard_query_keys } from './query_keys';

export const useListDashboards = (params?: ListDashboardsQueryVariables) =>
  useQuery(
    dashboard_query_keys.list(params),
    () => listAllDashboardsQuery(params),
    {
      select: (data) => data.map(dashboardGraphqlToModel),
    }
  );

export const useListDashboardTemplates = () =>
  useListDashboards({ filter: { user_id: { attributeExists: false } } });

export const useListDashboardsForUser = (
  params?: DashboardByUserQueryVariables
) =>
  useQuery(
    dashboard_query_keys.list(params),
    () => listAllDashboardsForUserQuery(params),
    {
      select: (data) => data.map(dashboardGraphqlToModel),
      enabled: !!params?.user_id,
    }
  );

export const useTabletDashboardForUser = (user_id?: string) => {
  const params = {
    user_id,
    filter: {
      device_type: { eq: DashboardDeviceType.tablet },
    },
  } as DashboardByUserQueryVariables;

  return useQuery(
    dashboard_query_keys.list(params),
    () => listAllDashboardsForUserQuery(params),
    {
      enabled: !!user_id,
      select(data) {
        if (data.length) {
          return dashboardGraphqlToModel(data[0]);
        } else {
          return undefined;
        }
      },
    }
  );
};
